import React, { useCallback, useState } from "react";
import { useField } from "formik";
import { useFieldError, useUpdateEffect } from "@/hooks";
import { ValidationMessage } from "../ValidationMessage";
import { Dropzone } from "@/components/ui/Dropzone";

const FormDropzone = (props) => {
  const { name, multiple = false, onChange, ...rest } = props;
  const [, meta, helpers] = useField(name);
  const hasError = useFieldError(name);

  // Initialize state based on whether it's multiple or single file
  const [currentValue, setCurrentValue] = useState(() => {
    const initialValue = meta.value || meta.initialValue;
    if (multiple) {
      return Array.isArray(initialValue) ? initialValue : [];
    } else {
      return initialValue || null;
    }
  });

  // Sync with Formik value changes
  useUpdateEffect(() => {
    setCurrentValue(meta.value);
  }, [meta.value]);

  const handleChange = useCallback(
    (files) => {
      let newValue;

      if (multiple) {
        newValue = Array.isArray(files) ? files : files ? [files] : [];
      } else {
        newValue = Array.isArray(files) ? files[0] || null : files;
      }

      setCurrentValue(newValue);
      helpers.setValue(newValue);
      helpers.setTouched(true);
      helpers.setError("");

      if (onChange) {
        onChange(newValue);
      }
    },
    [helpers, onChange, multiple]
  );

  return (
    <div className="flex flex-col space-y-2">
      <Dropzone
        {...rest}
        multiple={multiple}
        value={currentValue}
        onFileSelect={handleChange}
        className={hasError ? "border-red-500" : ""}
      />
      <ValidationMessage name={name} />
    </div>
  );
};

export { FormDropzone };
